<template>
  <HomepageSecondaryLayout>

     <div class="vheight">
      <div class="vcenter">
        <div class="vblock">
          <div class="wrapper">

            <!-- Form Heading -->
            <h2>Send us an email </h2>
            <form @submit.prevent="submit">
              <b-form-group class="contact-form" id="new_sign_up">

                <!-- Name -->
                <div class=form-label>Your Name
                  <span id="required">(required)</span>
                </div>
                <b-form-input v-model="name" placeholder="Your Name" required="required" type="text" class="contact-us-input" autofocus="autofocus" name="contact_us_[name]"></b-form-input>

                <!-- Email -->
                <div class=form-label>Your Email
                  <span id="required">(required)</span>
                </div>
                <b-form-input v-model="email" placeholder="Your email address" required="required" type="email" class="contact-us-input" autofocus="autofocus" name="contact_us_[email]" pattern="[^@]+@[^@]+\.[a-zA-Z]*"></b-form-input>

                <!-- Message -->
                <div class=form-label>Message
                  <span id="required">(required)</span>
                </div>
                <b-form-textarea v-model="message" placeholder="Your message" :rows="3" :max-rows="6" required="required" type="text" class="contact-us-input" autofocus="autofocus" name="contact_us_[message]"></b-form-textarea>

                <b-button type="submit" name="commit" class="contact-us-submit" :disabled="!formValid">
                  Submit
                </b-button>

              </b-form-group>
            </form>
          </div>
        </div>
      </div>
         <div class="hero-bottom">
          <img src="/static/images/footer/product_footer.png">
       </div>
    </div>

  </HomepageSecondaryLayout>

</template>

<style scoped lang="scss">
@import '~scss/colors';

/* Contact Us */

.vheight {
  display: flex;
  flex-direction: column;
  height:100%;
  background:#f9f9f9;
}

.vblock{
  display: block;
  width:100%;
}

.vcenter {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  min-height:calc(100vh - 300px);
}

.wrapper {
  max-width: 450px;
  margin: 20px auto;
}

h2 {
  margin-bottom: 20px;
}

.form-label {
  font-weight: 600;
  font-size: 0.85em;
}

#required {
  font-weight: 400;
  font-size: 0.75em;
}

.contact-form {
  width: 100%;
}

.contact-us-input,
.contact-us-submit {
  width: 100%;
  font-weight: 400;
  border-radius: 0;
  padding: 10px 20px;
  margin: 10px auto;
}

.contact-us-submit {
  background-color: $red;
  border: $red 1px solid;
  color: $white;
}

.hero-bottom img {
  bottom: 0;
  width: 100%;
  height: auto;
  max-width: 974px;
  object-fit: cover;
  margin-top: 0;
}

@media (max-width: 500px) {
 .wrapper {
   max-width:400px;
  }
}

@media (max-width: 415px) {
 .wrapper {
   max-width:300px;
  }
}

/* Portrait iPhoneX */
@media only screen
  and (min-device-width: 375px)
  and (max-device-width: 812px)
  and (-webkit-min-device-pixel-ratio: 3)
  and (orientation: portrait) {
    .vcenter {
      min-height:calc(100vh - 215px);
  }
}

/* Portrait and Landscape iPad */
@media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1366px)
  and (-webkit-min-device-pixel-ratio: 2) {
    .vcenter {
      min-height:100vh;
  }
}

</style>


<script>
import sendIntercomMessage from '@/lib/integrations/sendIntercomMessage';
export default {
  data() {
    return {
      name: "",
      email: "",
      message: ""
    };
  },
  computed: {
    formValid() {
      return (
        this.name &&
        this.email &&
        this.message
      );
    }
  },
  methods: {
    submit() {
      let { name, email, message } = this;
      sendIntercomMessage(message, {name, email}, true);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/homepage/Contact.vue